import classNames from 'classnames';
import React from 'react';

export interface TableCellProps extends React.HTMLProps<HTMLTableCellElement> {
  isHead?: boolean;
  isAccent?: boolean;
  header?: string;
}

const TableCell = ({
  children,
  isHead = false,
  isAccent = false,
  header,
  ...props
}: TableCellProps) => {
  return isHead ? (
    <th
      {...props}
      className={classNames(props.className, {
        'mss-table-cell--accent': isAccent
      })}
    >
      {children}
    </th>
  ) : (
    <td {...props}>
      {header && <div className="mss-table-cell-header">{header}</div>}
      {children}
    </td>
  );
};

export default TableCell;
